<template>
  <div
    class="absolute bottom-5 right-5 hidden md:block"
  >
    <div class="relative">
      <img
        src="~/assets/images/Te/TeCommon/Badge/Adobe/badge-yellow.png"
        alt="Adobe Creative Cloud Pro 個人版 3ヶ月付き！"
      >
      <p
        class="co-display-13 absolute m-auto flex flex-col justify-center leading-normal"
        style="inset: 0;"
      >
        <span class="co-display-14 mb-1">
          Adobe
          <br>
          Creative Cloud
          <br>
          Pro 個人版
          <br>
        </span>
        3ヶ月付き！
      </p>
    </div>
  </div>
</template>
